import React, {useEffect, useRef} from 'react';
import PropTypes from 'prop-types';

const MOBILE_WIDTH = 768;

export const SelectSearch = ({placeholder, onSearch}) => {
    const inputRef = useRef();

    useEffect(() => {
        if (window.innerWidth >= MOBILE_WIDTH) {
            inputRef.current.focus();
        }
    }, [inputRef]);

    return (
        <div className='select-search'>
            <input ref={inputRef} type="text" placeholder={placeholder} onKeyUp={(e) => onSearch(e)}/>
        </div>
    )
};

SelectSearch.propTypes = () => ({
    placeholder: PropTypes.string,
    onSearch: PropTypes.func,
});
